import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PinInput } from "@/components/PinInput";
import { Logo } from "@/components/Logo";
import { storage } from "@/lib/storage";
import { biometric } from "@/lib/biometric";
import { Fingerprint } from "lucide-react";

export default function Unlock() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const role = params.get("role") || "merchant";
  const next = params.get("next");
  const [error, setError] = useState("");
  const bioOn = biometric.isEnabled();
  const done = () => navigate(next || (role === "merchant" ? "/merchant" : "/customer"));

  const unlockWithFingerprint = async () => {
    try {
      if (await biometric.verify()) {
        storage.touchUnlock();
        done();
      }
    } catch (e) {
      setError("Fingerprint not recognised. Use your PIN.");
    }
  };

  useEffect(() => {
    if (!storage.getUser()) navigate("/", { replace: true });
    else if (!storage.hasPin()) navigate("/pin-setup", { replace: true });
  }, [navigate]);

  const handle = (pin) => {
    if (storage.verifyPin(pin)) {
      done();
    } else {
      setError("Incorrect PIN. Try again.");
    }
  };

  return (
    <div className="page-shell flex flex-col items-center" data-testid="unlock-page">
      <div className="w-full flex items-center justify-center mb-8 fade-slide-up">
        <Logo size={54} />
      </div>
      <div className="text-center mb-8 fade-slide-up" style={{ animationDelay: "0.08s" }}>
        <h1 className="text-3xl font-bold mb-2 gold-text">Welcome back</h1>
        <p className="text-sm text-[#F7E6B4]/60">
          Enter your 4-digit PIN to {role === "merchant" ? "open merchant dashboard" : "pay"}.
        </p>
      </div>
      <div className="fade-slide-up" style={{ animationDelay: "0.16s" }}>
        <PinInput onComplete={handle} label="Enter PIN" error={error} />
      </div>
      {bioOn && (
        <button
          onClick={unlockWithFingerprint}
          className="mt-8 btn-outline-gold rounded-full px-6 py-3 flex items-center gap-2 text-sm font-semibold fade-slide-up"
          data-testid="fingerprint-unlock-btn"
        >
          <Fingerprint size={18} /> Use fingerprint
        </button>
      )}
    </div>
  );
}
